import { HttpClient } from '../httpClient';
import TherapistSearchRequest from '../requests/therapistSearchRequest';
import TherapistResponse from '../responses/therapistResponse';
import TherapistRequest from '../requests/therapistRequest';
import DisciplinesResponse from '../responses/disciplinesResponse';
import UserResponse from '../responses/userResponse';
import {TherapistUserResponse, TherapistListResponse} from '../responses/therapistUserResponse';
import DistrictsResponse from '../responses/districtsResponse';
import User from '../models/user';
import { DataResponse } from '../responses/baseResponse';
import PaginatedResponse from '../responses/paginatedResponse';
import District from '../models/district';
import RejectWithFeedbackRequest from '../requests/rejectWithFeedbackRequest';
import DisciplinesWithTherapistCountModel from '../models/disciplinesWithTherapistCountModel';
import { selectOption } from '../../types/selectOption';

const httpClient = new HttpClient();

export const searchTherapists = async (
  therapistSearchRequest: TherapistSearchRequest
) => {
  return httpClient.post<PaginatedResponse<User>>({
    url: '/v1/admin/therapists/search',
    payload: therapistSearchRequest,
    requiresToken: true,
  });
};

export const getTherapists = async () => {
  return httpClient.get<TherapistResponse>({
    url: '/v1/therapistRoles/Therapists',
    requiresToken: true,
  });
};

export const getTherapist = async (therapistId: number) => {
  return httpClient.get<UserResponse>({
    url: `/v1/Admin/Therapists/${therapistId}`,
    requiresToken: true,
  });
};

export const getTherapistByUserId = async (userId: number) => {
  return httpClient.get<TherapistUserResponse>({
    url: `/v1/Admin/Therapists/ByUserId/${userId}`,
    requiresToken: true,
  });
};

export const getTherapistListByName = async (name: string) => {
  return httpClient.get<TherapistListResponse>({
    url: `/v1/Admin/Therapists/TherapistByName?name=${name}`,
    requiresToken: true,
  });
};

export const createTherapist = async (therapistRequest: TherapistRequest) => {
  return httpClient.post<TherapistResponse>({
    url: `/v1/admin/therapists/`,
    payload: therapistRequest,
    requiresToken: true,
  });
};

export const updateTherapist = async (
  therapistId: string,
  therapistRequest: TherapistRequest
) => {
  return httpClient.put<DataResponse<User>>({
    url: `/v1/admin/therapists/${therapistId}`,
    payload: therapistRequest,
    requiresToken: true,
  });
};

export const deleteTherapist = async (therapistId: number) => {
  return httpClient.delete<TherapistResponse>({
    url: `/v1/admin/therapists/${therapistId}`,
    requiresToken: true,
  });
};

export const getDisciplinesByTherapistId = async (therapistId: number) => {
  return httpClient.get<DisciplinesResponse>({
    url: `/v1/Billing/Caseloads/DisciplinesByTherapistId/${therapistId}`,
    requiresToken: true,
  });
};

export const getDistrictsByDivisionId = async (divisionId: number) => {
  return httpClient.get<DistrictsResponse>({
    url: `/v1/Admin/Therapists/DistrictsByDivisionId/${divisionId}`,
    requiresToken: true,
  });
};

export const getPendingTherapists = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: '/v1/BillingSpecialist/Therapists/Pending',
    requiresToken: true,
  });
};

export const approvePendingTherapistChanges = async (userId: number) => {
  return httpClient.get<DataResponse<User[]>>({
    url: `/v1/BillingSpecialist/Therapists/${userId}/approve`,
    requiresToken: true,
  });
};

export const rejectPendingTherapistChanges = async (userId: number, rejectRequest: RejectWithFeedbackRequest) => {
  return httpClient.post<DataResponse<User[]>>({
    url: `/v1/BillingSpecialist/Therapists/${userId}/reject`,
    payload: rejectRequest,
    requiresToken: true,
  });
};

export const getMyTeam = async (id: number) => {
  return httpClient.get<DataResponse<District[]>>({
    url: `/v1/Admin/Therapists/MyTeam/${id}`,
    requiresToken: true,
  });
};

export const getAllTherapists = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: '/v1/Admin/Therapists/Users',
    requiresToken: true,
  });
};

export const getByCurrentUser = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: '/v1/BillingSpecialist/Therapists',
    requiresToken: true,
  });
};

export const getTherapistNamesAndIds = async () => {
  return httpClient.get<DataResponse<selectOption[]>>({
    url: '/v1/Admin/Therapists/NamesAndIds',
    requiresToken: true,
  });
};

export const getDisciplinesWithTherapistCount = async () => {
  return httpClient.get<DataResponse<DisciplinesWithTherapistCountModel[]>>({
    url: '/v1/Admin/Therapists/GetDisciplinesWithTherapistCount',
    requiresToken: true,
  });
};